import * as stylex from '@stylexjs/stylex';
import { theme } from 'trellis-theming/theme.stylex';
const UNITLESS_NUMBER_REGEXP = /^\d+(\.\d+)?$/;
const _temp = {
  height: "xyq6l7l",
  width: "x1uyokj7",
  "$$css": true
};
const iconSizeStyles = {
  default: {
    height: "xlzyvqe",
    width: "x15vhz18",
    $$css: true
  },
  sm: {
    height: "xkjsi5h",
    width: "x17vri3s",
    $$css: true
  },
  md: {
    height: "x1kzezjn",
    width: "xr833f",
    $$css: true
  },
  lg: {
    height: "x1c0zijx",
    width: "xrw5dbu",
    $$css: true
  },
  custom: value => [_temp, {
    "--x-blockSize": (val => typeof val === "number" ? val + "px" : val != null ? val : undefined)(value),
    "--x-inlineSize": (val => typeof val === "number" ? val + "px" : val != null ? val : undefined)(value)
  }]
};

/**
 * Normalizes the `size` prop passed to icon components into a StyleX style that sets the icon's
 * `block-size`/`inline-size` (icons are square, so both use the same value).
 *
 * - `undefined` / `"inherit"` → the `default` style (`1em`), which matches the surrounding text size.
 * - `"sm"` / `"md"` / `"lg"` → a predefined style backed by the `ui-icon-size-*` design
 *   tokens, so named sizes never drift from the theme.
 * - A bare number string like `"200"` → throws an error. Unitless numbers are not valid CSS lengths
 *   and would cause the SVG to render at 0×0.
 * - Any other string (e.g. `"16px"`, `"1.5em"`, `"auto"`, `"var(--token)"`) → a dynamic style that
 *   passes the value through unchanged.
 *
 * Limitations:
 * - The unitless check only catches literal strings passed directly in JSX (e.g. size="200").
 *   When a design token is used (e.g. size={myVars['icon-size']}), what arrives here is the
 *   CSS custom property reference string ("var(--my-token)"), not the resolved value. If the
 *   token itself resolves to a unitless number in CSS, the icon will silently render at 0×0
 *   and this check will not catch it — CSS custom properties are resolved by the browser after
 *   JavaScript has already run.
 */
export const normalizeSizeProp = (sizeProp, displayName) => {
  if (sizeProp == null || sizeProp === 'inherit') {
    return iconSizeStyles.default;
  }
  if (sizeProp === 'sm' || sizeProp === 'md' || sizeProp === 'lg') {
    return iconSizeStyles[sizeProp];
  }
  if (UNITLESS_NUMBER_REGEXP.test(sizeProp)) {
    throw new Error(`[${displayName}] size="${sizeProp}" is not a valid CSS length. ` + `Use a value with a unit instead (e.g. "${sizeProp}px", "1em").`);
  }
  return iconSizeStyles.custom(sizeProp);
};